// extracted by mini-css-extract-plugin
module.exports = {"phone":"ActionContents_phone__3i1Oi"};